// src/types/companyPolicy.ts
export interface CompanyPolicy {
  id?: string;
  title: string;
  category: string;
  content: string; // markdown
  is_active?: boolean;
  sort_order?: number;
  branchID?: string;
  created_at?: string;
  updated_at?: string;
}

// Suggested categories surfaced in the editor. Admins can still type a custom one.
export const POLICY_CATEGORIES: string[] = [
  'Human Resources',
  'Code of Conduct',
  'IT & Workplace',
  'Leave & Attendance',
  'Health & Safety',
  'Finance & Expenses',
  'General',
];
